import React from "react";
import { ImSpinner2 } from "react-icons/im";

const Spinner = ({ height }) => {
  return (
    <ImSpinner2 className={`animate-spin ${height ?? "h-5"} text-purple-700`} />
  );
};

export default Spinner;
